import { SelectField } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { serviceTypeToName } from "../../helper/serviceType";

const SERVICE_TYPES = ["EMBROIDERY", "PRINT"];

type SelectServiceTypeProps = {
  isDisabled?: boolean;
};

export const SelectService: React.FC<SelectServiceTypeProps> = ({
  isDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <SelectField
      name="service_type"
      label={t("designMappings.actions.add.form.label.service_type")}
      style={{ width: "100%" }}
      options={SERVICE_TYPES.map((typeId) => ({
        label: t(`designMappings.service.types.${serviceTypeToName(typeId)}`),
        value: typeId,
      }))}
      disabled={isDisabled}
    />
  );
};
